// pages/Dashboard.jsx
import ShippingPolicy from "../../components/home/policyComponents/ShippingPolicy";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <ShippingPolicy />
    </HomeLayout>
  );
}
